import { zoneImages } from "../../../../lib/constants/globalConstant";

export const calculateSubtotal = (zones) => {
    return zones.reduce((total, zone) => {
      const zoneSubtotal = zone.tokens?.reduce(
        (sum, token) =>
          sum +
          (token.purchaseType === "1"
            ? token.tokenPrice
            : token.tokenPrice * (token.matchIds?.length || 0)),
        0
      );
      return total + zoneSubtotal;
    }, 0);
};

export const calculateTokenDetails = (zones) => {
    return zones.flatMap((zone) =>
      zone.tokens?.map((token) => {
        const quantity = token.matchIds?.length || 0;
        const adjustedTokenPrice =
          token.purchaseType === "1"
            ? token.tokenPrice
            : token.tokenPrice * quantity;

        return {
          ...token,
          zoneName: zone.zoneName,
          quantity,
          adjustedTokenPrice,
        };
      })
    );
};

export const zoneImage = (zoneCategoryName) => zoneImages[zoneCategoryName] || null;